export const setCreatedByList = (state) => ({
    type: 'SET_CREATEDBY_LIST',
    createdBy: state
});
export { setCreatedByList as default };
